<i class="material-icons">done</i>
<div class="space"></div>
<ng-container i18n="@@duplicatedSuccessfully">Duplicated successfully</ng-container>